import store from "@/store";
import request from "@/utils/extRequest";

export async function getUserJoinYn(loginId) {
    console.log("@@ get list : getUserJoinYn");
    let result = request.get(`/api/ext/idMst/${loginId}`);
    return result;
}

// 서류인증 : Ycloud 교사 인증하기 
export async function setYcloudUserTeacherCertify(params) {
    console.log("@@ post : setYcloudUserTeacherCertify");
    let result = request.post("/api/ext/idMst/certify", params);
    return result;
}

// 서류인증 : Ycloud 교사 인증거절하기
export async function setYcloudUserTeacherReject(params) {
    console.log("@@ post : setYcloudUserTeacherReject");
    let result = request.post("/api/ext/idMst/reject", params);
    return result;
}

// 서류인증 : Ycloud 교사 인증파일 삭제하기
export async function deleteYcloudUserTeacherFile(params) {
    console.log("@@ delete : deleteYcloudUserTeacherFile");
    let result = request.post("/api/ext/idMst/deleteFile", params);
    return result;
}

// 정희원취소 : Ycloud 교사
export async function setYcloudUserTeacherCancelRegular(params) {
    console.log("@@ post : setYcloudUserTeacherCancelRegular");
    //정회원취소와 Ycloud 교사 인증거절하기가 동일한 내용임
    let result = request.post("/api/ext/idMst/reject", params);
    return result;
}

// 서류인증 : Booksam 교사 인증하기 
export async function setBooksamUserTeacherCertify(params) {
    console.log("@@ post : setBooksamUserTeacherCertify");
    let result = request.post("/api/ext/bsUser/certify", params);
    return result;
}

// 서류인증 : Booksam 교사 인증거절하기
export async function setBooksamUserTeacherReject(params) {
    console.log("@@ post : setBooksamUserTeacherReject");
    let result = request.post("/api/ext/bsUser/reject", params);
    return result;
}

// 서류인증 : Booksam 교사 인증파일 삭제하기
export async function deleteBooksamUserTeacherFile(params) {
    console.log("@@ delete : deleteBooksamUserTeacherFile");
    let result = request.post("/api/ext/bsUser/deleteFile", params);
    return result;
}

// 정회원취소 : Booksam 교사
export async function setBooksamUserTeacherCancelRegular(params) {
    console.log("@@ post : setBooksamUserTeacherCancelRegular");
    //정회원취소와 Booksam 교사 인증거절하기 동일한 내용임
    let result = request.post("/api/ext/bsUser/reject", params);
    return result;
}